import { observable, computed, action } from 'mobx';
import { NotificationDeliveryIndexView } from '../../types/notification_deliveries';
import { NotificationDeliveryApis } from '../../apis/notification_delivery';
import { SubmitState } from '../../../commonv3/states/SubmitState';

export class NotificationDeliveryListState {
    @observable totalPages: NotificationDeliveryIndexView[][] = [];
    @observable loadingState = new SubmitState();

    async init() {
        await this.fetchNextPage();
    }

    @action.bound
    async fetchNextPage() {
        // lastNotificationIdより小さいNotificationDeliveryを取得したいため、-1した数字を最大値 = maxId（inclusive）として定義する
        const maxId = this.lastNotification ? this.lastNotification.id - 1 : null;
        await this.loadingState.operate(async () => {
            // maxId以降のnotificationDeliveryを8つ取得する
            const nextPage = await NotificationDeliveryApis.getNextPage(maxId);
            this.totalPages = this.totalPages.concat([nextPage]);
        });
    }

    @computed
    // 一番最後に読み込んだページの中で、最後の通知を1つ返す
    get lastNotification(): NotificationDeliveryIndexView | null {
        if (this.lastPage == null) {
            return null;
        }
        if (this.lastPage.length === 0) {
            return null;
        }
        return this.lastPage[this.lastPage.length - 1];
    }

    @computed
    //一番最後に読み込んだページを返す
    get lastPage(): NotificationDeliveryIndexView[] | [] {
        if (this.totalPages.length === 0) {
            return null;
        }
        return this.totalPages[this.totalPages.length - 1];
    }

    @computed
    get hasNextPage(): boolean {
        const PER_PAGE = 8;
        if (!this.lastPage) {
            return false;
        }
        return this.lastPage.length === PER_PAGE;
    }

    @computed
    get loading() {
        return this.loadingState.submitting;
    }
}
